import { Constants } from '../../app.const';

export class WorkConstants {

    public static basicConstans = Constants;

    public static baseUrl: string = Constants.baseUrl;
    public static apiUrl: string = Constants.baseUrl + Constants.apiVersioning;
    public static appUrl: string = Constants.appUrl;
    public static loginUrl: string = Constants.loginUrl;
    public static imageUrl: string = Constants.imageUrl;
    public static apiVersioning: string = Constants.apiVersioning;
    public static endPoint: string = Constants.endPoint;

    //PARAMS
    public static readonly paramsProjectId: string = "projectId"
    public static readonly paramsSprintId: string = "sprintId"
    public static readonly paramsTaskId: string = "taskId"
    public static readonly paramsTaskType: string = "taskType";
    public static readonly paramsVersionId: string = "versionId";
    public static readonly paramsStatus: string = "status";
    public static readonly paramsTimeSheetId: string = "timesheetId";
    public static readonly paramsPageId: string = "pageId"

    //API 
    public static apiCreateSprint: string = 'projects/{' + WorkConstants.paramsProjectId + '}/sprints';
    public static apiEditTask: string = 'tasks/{' + WorkConstants.paramsTaskType + '}/{' + WorkConstants.paramsTaskId + '}';
    public static getSprintBoard: string = 'sprints/{' + WorkConstants.paramsSprintId + '}/board';
    public static updateSprintBoard: string = 'sprints/{' + WorkConstants.paramsSprintId + '}/task/{' + WorkConstants.paramsTaskId + '}/version/{' + WorkConstants.paramsVersionId + '}/board/{' + WorkConstants.paramsStatus + '}';
    public static getTimeSheets: string = 'tasks/{' + WorkConstants.paramsTaskId + '}/sprint/{' + WorkConstants.paramsSprintId + '}/timesheets';
    public static apiEditTaskTimes: string = 'tasks/timeupdate/{' + WorkConstants.paramsTaskId + '}';
    public static editTimeSheets: string = 'tasks/{' + WorkConstants.paramsTaskId + '}/sprint/{' + WorkConstants.paramsSprintId + '}/version/{' + WorkConstants.paramsVersionId + '}/timesheets/{' + WorkConstants.paramsTimeSheetId + '}';
    public static projectTimeLine: string = 'timeline/project/{' + WorkConstants.paramsProjectId + '}';
    public static deleteTimeSheet: string = 'timesheet/{' + WorkConstants.paramsTimeSheetId + '}';
    public static getProjectId: string = 'projects/{' + WorkConstants.paramsProjectId + '}/documents';

    //ROUTES
    static routeSprint: string = "sprint";
    static routeProjectDetails: string = "project_detail";

    //LINK
    static linkSprint: string = Constants.routeProjects + '/' + WorkConstants.routeSprint;
    static linkProjectDetails: string = Constants.routeProjects + '/' + WorkConstants.routeProjectDetails;

    //ROUTE_DATA
    public static routeDataWork: string = 'WORK';
    public static routeDataProjects: string = 'PROJECTS';

    public static taskStatus = {
        "1": ["NEW", "label-primary"],
        "2": ["IN_PROGRESS", "label-primary"],
        "3": ["PENDING", "label-primary"],
        "4": ["BLOCKED", "label-primary"],
        "5": ["READY", "label-primary"],
        "6": ["DONE", "label-primary"],
        "7": ["DEFERRED", "label-primary"]
    }
    public static fileType = {
        "pdf": "../../../../assets/img/pdf1.png",
        "png": "../../../../assets/img/png1.png",
        "txt": "../../../../assets/img/txt1.png",
        "jpg": "../../../../assets/img/jpg1.png",
        "xlsx": "../../../../assets/img/xl1.png",
        "other": "../../../../assets/img/oth1.png"
    }
    public static taskStatusLoop = [
        { "1": ["NEW", "tsk-new"] },
        { "2": ["IN_PROGRESS", "tsk-inprogress"] },
        { "3": ["PENDING", "tsk-pending"] },
        { "4": ["BLOCKED", "tsk-ready"] },
        { "5": ["READY", "tsk-done"] },
        { "6": ["DONE", "tsk-blocked"] },
        { "7": ["DEFERRED", "tsk-deffrred"] }];

    // Google drive 
    // public static driveFile = "https://www.googleapis.com/auth/drive.file"
};


// WEBPACK FOOTER //
// ./src/app/modules/work/work.const.ts